import { Input, useGridFilterUrlContext } from '@finbeat/react-toolkit';
import { TariffsFilter as TariffsFilterType } from 'models/api/tariff';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

const TariffsFilter = () => {
    const { t } = useTranslation();
    const { draftFilter, setDraftFilter } = useGridFilterUrlContext<TariffsFilterType>();

    const changeInputProp = (e: ChangeEvent<HTMLInputElement>) =>
        changeProp(e.target.value, e.target.name);

    const changeProp = (value: string, name: string) => {
        setDraftFilter((prev) => ({ ...prev, [name]: value }));
    };

    const { id, name } = draftFilter;

    return (
        <Row>
            <Col>
                <Input
                    id="id"
                    value={id}
                    name="id"
                    onChange={changeInputProp}
                    label={t('BackOfficeId')}
                />
            </Col>
            <Col>
                <Input
                    id="name"
                    value={name}
                    name="name"
                    onChange={changeInputProp}
                    label={t('BackOfficeName')}
                />
            </Col>
        </Row>
    );
};

export default TariffsFilter;
